import React from 'react';
import './ForwardMeetingModalSkeleton.css';

/**
 * Skeleton loader for forward meeting modal user list
 */
const ForwardMeetingModalSkeleton = () => {
  return (
    <div className="fm-skeleton-container">
      <div className="fm-skeleton-search">
        <div className="fm-skeleton-search-input" />
      </div>
      <div className="fm-skeleton-user-list">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="fm-skeleton-user-item">
            <div className="fm-skeleton-avatar" />
            <div className="fm-skeleton-user-info">
              <div className="fm-skeleton-user-name" />
              <div className="fm-skeleton-user-email" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ForwardMeetingModalSkeleton;
